import { cn } from "@/lib/utils";
import { Heading } from "./ui";

type QuestionHeadingProps = {
  children?: React.ReactNode;
  required?: boolean;
  className?: string;
};

const QuestionHeading = ({ children, required, className = '' }: QuestionHeadingProps) => {
  return (
    <Heading level={2} className={cn('text-lg text-center border-0', className)}>
      {children}
      {required && <span className="text-gray-500">{'\u00A0'}*</span>}
    </Heading>
  );
};

export default QuestionHeading;